import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ConfigProvider } from "@/lib/config";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Chat from "@/pages/Chat";
import History from "@/pages/History";
import Admin from "@/pages/Admin";
import Notifications from "@/pages/Notifications";
import SettingsPage from "@/pages/Settings";
import TeamUsage from "@/pages/TeamUsage";
import AppShell from "@/components/layout/AppShell";
import { Toaster } from "sonner";

function Private({ children, managerOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-ink-soft">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (managerOnly && user.role !== "manager") return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Chat />} />
        <Route path="/c/:cid" element={<Chat />} />
        <Route path="/history" element={<History />} />
        <Route path="/admin" element={<Private managerOnly><Admin /></Private>} />
        <Route path="/notifications" element={<Private managerOnly><Notifications /></Private>} />
        <Route path="/team-usage" element={<Private managerOnly><TeamUsage /></Private>} />
        <Route path="/settings" element={<Private managerOnly><SettingsPage /></Private>} />
      </Routes>
    </AppShell>
  );
}

export default function App() {
  return (
    <ConfigProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/*" element={<Private><Shell /></Private>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  );
}
